module.exports = __webpack_public_path__ + "static/img/exposure-mobile-2.174755f5.png";